import { css } from '@emotion/react';
import LinkIcon from '@atlaskit/icon/core/link';
import { token } from '@atlaskit/tokens';
import UnlockIcon from '@atlaskit/icon/core/lock-unlocked';
import Tooltip from '@atlaskit/tooltip';
import { useState } from 'react';

// Import the styles

const shareButton = css`
  display: inline-flex;
  border: 1px solid #0b120e24;
  border-radius: 0px;
  overflow: hidden;
  color: #505258;
  height: 25px !important;
  width: 108px !important;
  font-size: 14px !important;
  margin-right: 0.75rem;
  border-radius: 3px;
`;

const shareButtonButton = css`
  background: white;
  border-left: none;
  border-top: none;
  border-bottom: none;
  border-right: 1px solid #ccc;
  color: #505258;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s;
  padding: 6px 12px 6px 8px;
  column-gap: 4px;
  font-weight: 500 !important;


  &:hover {
    background-color: ${token('color.background.neutral.subtle.hovered')};
  }

  &:focus {
    background-color: ${token('color.background.neutral.subtle.pressed')};
  }
}`;

const shareButtonRight = css`
  background: white;
  border: none;
  padding: 8px 8px;
  color: #505258;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background-color: ${token('color.background.neutral.hovered')};
  }

  &:focus {
    background-color: ${token('color.background.neutral.pressed')};
  }
}`;

export default function ShareButton({
  onShare,
  onCopyLink
}: {
  onShare: () => void;
  onCopyLink: () => void;
}) {
  const copyLinkClicked = () => {
    setCopyStatus(COPY_COMPLETED);
    onCopyLink();
  };

  const COPY_INFO = 'Copy link';
  const COPY_COMPLETED = 'Copied!';

  const SHARE_TOOLTIP = 'Open - Anyone with public link can access';

  const [copyStatus, setCopyStatus] = useState(COPY_INFO);

  return (
    <div css={shareButton}>
      <Tooltip content={SHARE_TOOLTIP} position="top">
        {(tooltipProps) => (
          <button {...tooltipProps} css={shareButtonButton} onClick={onShare}>
            <UnlockIcon label="Share" />
            {'Share'}
          </button>
        )}
      </Tooltip>
      <Tooltip content={copyStatus} position="top">
        {(tooltipProps) => (
          <button
            {...tooltipProps}
            css={shareButtonRight}
            onClick={copyLinkClicked}
          >
            <LinkIcon label="Copy Link" />
          </button>
        )}
      </Tooltip>
    </div>
  );
}
